<template>
  <div class="mainContainer">
    <router-view />
  </div>
</template>
<script setup>
</script>
<style>
.mainContainer {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  font-size: 1vw;
  font-family: 'Cairo', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

/* Global Cairo font for all components (PrimeVue + app) */
html, body, #app,
.p-component, .p-inputtext, .p-button, .p-dropdown, .p-multiselect,
.p-datatable, .p-dialog, .p-menu, .p-toast, .p-tag, .p-chip,
.p-paginator, .p-calendar, .p-checkbox, .p-radiobutton,
.enhanced-table, .column-header, .cell-content {
  font-family: 'Cairo', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
}

.p-datatable {
  font-size: 1vw;
}

.scrollable {
  cursor: auto;
}

::-webkit-scrollbar {
  width: 0.5vw;
  height: 1vh;
  cursor: pointer;
}

::-webkit-scrollbar-track {
  background: #fafafa;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #a3a3a3;
  border-radius: 10px;
}

/* :global(.p-dialog .p-dialog-header){
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: space-between !important;
  align-content: center !important;
  background-color: black;
} */

input[type="file"] {
  /* Hide the default file input button */
  display: none;
}

.p-dialog .p-dialog-footer {
  display: flex !important;
  direction: rtl !important;
  justify-content: space-between !important;
}

.p-column-filter-overlay-menu .p-column-filter-constraint .p-column-filter-matchmode-dropdown {
  margin-bottom: 0.5rem;
  display: none;
}
.p-datatable .p-datatable-tbody > tr > td   
 {
  font-size: 16px;
}
.p-datatable .p-datatable-thead > tr > th   
 {
  font-size: 16px;
}
.p-dialog .p-dialog-content{
  height: 100%;
}

/* ========================================
   ENHANCED TABLE STYLES - GLOBAL
   ======================================== */

/* Enhanced Table Styles */
.enhanced-table {
    background: white;
    border-radius: 12px;
    overflow: visible;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.enhanced-table .p-datatable-thead > tr > th {
    background: #f8fafc !important;
    border: none !important;
    padding: 1rem 0.75rem !important;
    font-weight: 600 !important;
    color: #374151 !important;
    border-bottom: 2px solid #e5e7eb !important;
}

.enhanced-table .p-datatable-tbody > tr > td {
    border: none !important;
    padding: 1rem 0.75rem !important;
    border-bottom: 1px solid #f3f4f6 !important;
}

.p-datatable-header {
    background-color: white !important;
    border-color: white !important;
    border-width: 0 !important;
}

.p-datatable .p-datatable-tbody > tr.p-highlight {
    background: white !important;
    color: black !important;
}

/* ========================================
   HEADER DESIGN STYLES - GLOBAL
   ======================================== */

.search-header-container {
    width: 100%;
    margin-bottom: 1rem;
}

.search-filters-section {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.single-row-layout {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    align-items: end;
}

.search-input {
    height: 50px;
    border-radius: 8px;
    border: 2px solid #e5e7eb;
    transition: all 0.3s ease;
    max-width: 250px;
    width: 100%;
}

.search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
    width: 100%;
}

.filter-label {
    font-weight: 600;
    color: #374151;
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
}

.filter-dropdown {
    height: 50px;
    border-radius: 8px;
    min-width: 180px;
    max-width: 250px;
    width: 100%;
}

.filter-dropdown .p-dropdown {
    height: 50px;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    transition: all 0.3s ease;
    width: 100%;
}

.filter-dropdown .p-dropdown:not(.p-disabled).p-focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.search-btn {
    height: 45px;
    padding: 0 2rem;
    background: linear-gradient(135deg, #14a845 0%, #16a34a 100%);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(20, 168, 69, 0.3);
}

.search-btn:hover {
    background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(20, 168, 69, 0.4) !important;
}

.search-btn:active {
    transform: translateY(0);
}

/* ========================================
   COLUMN HEADER STYLES - GLOBAL
   ======================================== */

/* Column header styles moved to `src/assets/global.css` */

/* ========================================
   COLUMN FILTER STYLES - GLOBAL
   ======================================== */

.p-column-filter-menu {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.p-column-filter-menu[dir="rtl"] {
    flex-direction: row-reverse;
    gap: 0.75rem;
}

.p-column-filter-menu[dir="ltr"] {
    flex-direction: row;
    gap: 0.5rem;
}

.p-column-filter-menu i {
    font-size: 0.9rem;
    opacity: 0.9;
}

.p-column-filter-menu[dir="rtl"] i {
    margin-left: 0.5rem;
    margin-right: 0;
}

.p-column-filter-menu[dir="ltr"] i {
    margin-right: 0.5rem;
    margin-left: 0;
}

/* Additional RTL spacing for filter icons */
.p-column-filter-menu[dir="rtl"] .fa-solid,
.p-column-filter-menu[dir="rtl"] .fa-regular,
.p-column-filter-menu[dir="rtl"] .fa-brands,
.p-column-filter-menu[dir="rtl"] .pi {
    margin-left: 0.5rem;
    margin-right: 0;
}

.p-column-filter-menu[dir="ltr"] .fa-solid,
.p-column-filter-menu[dir="ltr"] .fa-regular,
.p-column-filter-menu[dir="ltr"] .fa-brands,
.p-column-filter-menu[dir="ltr"] .pi {
    margin-right: 0.5rem;
    margin-left: 0;
}

/* Column filter input spacing */
.p-column-filter[dir="rtl"] {
    text-align: right;
    padding-right: 0.75rem;
    padding-left: 0.5rem;
}

.p-column-filter[dir="ltr"] {
    text-align: left;
    padding-left: 0.75rem;
    padding-right: 0.5rem;
}

/* Column filter menu button spacing */
.p-column-filter-trigger[dir="rtl"] {
    margin-left: 0.5rem;
    margin-right: 0;
}

.p-column-filter-trigger[dir="ltr"] {
    margin-right: 0.5rem;
    margin-left: 0;
}

/* ========================================
   COLUMN HEADER FILTER ICON SPACING - GLOBAL
   ======================================== */












/* Universal RTL filter trigger icon spacing */
[dir="rtl"] .p-column-filter-trigger-icon {
    margin-left: 0.5rem !important;
    margin-right: 0 !important;
}

/* Universal LTR filter trigger icon spacing */
[dir="ltr"] .p-column-filter-trigger-icon {
    margin-right: 0.5rem !important;
    margin-left: 0 !important;
}







/* ========================================
   CELL CONTENT STYLES - GLOBAL
   ======================================== */

/* Cell content styles moved to `src/assets/global.css` */

/* ========================================
   STRIPED ROWS - GLOBAL
   ======================================== */

.enhanced-table .p-datatable-tbody > tr:nth-child(even) {
    background-color: #f8fafc !important;
}

.enhanced-table .p-datatable-tbody > tr:nth-child(odd) {
    background-color: white !important;
}

.enhanced-table .p-datatable-tbody > tr:hover {
    background-color: #e0f2fe !important;
    transition: background-color 0.2s ease;
    cursor: pointer;
}

/* ========================================
   CELL TYPE STYLES - GLOBAL
   ======================================== */

/* ID Cell Styles */
.id-cell {
    color: #6b7280;
    font-weight: 600;
    font-family: 'Courier New', monospace;
    text-align: right;
}

.id-cell[dir="ltr"] {
    text-align: left;
}

/* Name Cell Styles */
.name-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.name-cell[dir="ltr"] {
    text-align: left;
}

/* Date Cell Styles */
.date-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.date-cell[dir="ltr"] {
    text-align: left;
}

/* Time Cell Styles */
.time-cell {
    font-weight: 600;
    color: #059669;
    text-align: right;
}

.time-cell[dir="ltr"] {
    text-align: left;
}

/* From Stop Cell Styles */
.from-stop-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.from-stop-cell[dir="ltr"] {
    text-align: left;
}

/* To Stop Cell Styles */
.to-stop-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.to-stop-cell[dir="ltr"] {
    text-align: left;
}

/* Bus Type Cell Styles */
.bus-type-cell {
    font-weight: 500;
    color: #3b82f6;
    text-align: right;
}

.bus-type-cell[dir="ltr"] {
    text-align: left;
}

/* Bus Captain Cell Styles */
.bus-captain-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.bus-captain-cell[dir="ltr"] {
    text-align: left;
}

/* Booking Cell Styles */
.booking-cell {
    font-weight: 600;
    color: #059669;
    text-align: right;
}

.booking-cell[dir="ltr"] {
    text-align: left;
}

/* Vehicle Cell Styles */
.vehicle-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.vehicle-cell[dir="ltr"] {
    text-align: left;
}

/* Seats Cell Styles */
.seats-cell {
    font-weight: 600;
    color: #059669;
    text-align: right;
}

.seats-cell[dir="ltr"] {
    text-align: left;
}

/* Max Seats Cell Styles */
.max-seats-cell {
    font-weight: 600;
    color: #059669;
    text-align: right;
}

.max-seats-cell[dir="ltr"] {
    text-align: left;
}

/* Name En Cell Styles */
.name-en-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.name-en-cell[dir="ltr"] {
    text-align: left;
}

/* Name Ar Cell Styles */
.name-ar-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.name-ar-cell[dir="ltr"] {
    text-align: left;
}

/* Type Cell Styles */
.type-cell {
    font-weight: 500;
    color: #059669;
    text-align: right;
}

.type-cell[dir="ltr"] {
    text-align: left;
}

/* Make Cell Styles */
.make-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.make-cell[dir="ltr"] {
    text-align: left;
}

/* Icon Cell Styles */
.icon-cell {
    font-weight: 500;
    color: #059669;
    text-align: center;
    font-size: 1.2rem;
}

.icon-cell[dir="ltr"] {
    text-align: center;
}

/* Image Cell Styles */
.image-cell {
    text-align: center;
}

.image-cell[dir="ltr"] {
    text-align: center;
}

/* Area Cell Styles */
.area-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.area-cell[dir="ltr"] {
    text-align: left;
}

/* Price Cell Styles */
.price-cell {
    font-weight: 600;
    color: #059669;
    text-align: right;
}

.price-cell[dir="ltr"] {
    text-align: left;
}

/* Test Cell Styles */
.test-cell {
    text-align: center;
}

.test-cell[dir="ltr"] {
    text-align: center;
}

/* Customer Cell Styles */
.customer-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.customer-cell[dir="ltr"] {
    text-align: left;
}

/* Model Cell Styles */
.model-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.model-cell[dir="ltr"] {
    text-align: left;
}

/* Year Cell Styles */
.year-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.year-cell[dir="ltr"] {
    text-align: left;
}

/* Captain Name Cell Styles */
.captain-name-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.captain-name-cell[dir="ltr"] {
    text-align: left;
}

/* Employee Name Cell Styles */
.employee-name-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.employee-name-cell[dir="ltr"] {
    text-align: left;
}

/* Email Cell Styles */
.email-cell {
    font-weight: 500;
    color: #374151;
    text-align: right;
}

.email-cell[dir="ltr"] {
    text-align: left;
}

/* Status Cell Styles */

/* Status and action cell styles have been centralized. See:
    src/assets/global.css
    This file contains the full definitions for .status-cell and .actions-cell
    including directional (RTL/LTR) variants, responsive rules and button sizing.
*/

/* Ensure Actions column header is always visible */
.enhanced-table .p-datatable-thead .p-datatable-frozen-right {
    background: #f8fafc !important;
    position: sticky !important;
    right: 0 !important;
    z-index: 10 !important;
}

.enhanced-table[dir="rtl"] .p-datatable-thead .p-datatable-frozen-right {
    background: #f8fafc !important;
    position: sticky !important;
    left: 0 !important;
    right: auto !important;
    z-index: 10 !important;
}

/* Fix RTL Actions column header */
.enhanced-table[dir="rtl"] .p-datatable-thead .p-datatable-frozen-left {
    background: #f8fafc !important;
    position: sticky !important;
    left: 0 !important;
    right: auto !important;
    z-index: 10 !important;
}

/* Button-related DataTable overrides moved to:
    src/assets/global.css
     See that file for .action-btn and DataTable directional/button rules.
*/

/* Success Green Buttons */
.layout-btn, .price-btn, .show-btn, .bus-btn {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
    color: white !important;
}

.layout-btn:hover, .price-btn:hover, .show-btn:hover, .bus-btn:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3) !important;
}

/* Danger Red Buttons */
.delete-btn, .cancel-btn, .ban-btn, .change-bus-btn {
    background: linear-gradient(135deg, #ff5e5e 0%, #dc2626 100%) !important;
    color: white !important;
}

.delete-btn:hover, .cancel-btn:hover, .ban-btn:hover, .change-bus-btn:hover {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3) !important;
}

/* Warning Orange Buttons */
.hide-btn, .facilities-btn {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
    color: white !important;
}

.hide-btn:hover, .facilities-btn:hover {
    background: linear-gradient(135deg, #d97706 0%, #b45309 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3) !important;
}

/* Info Blue Buttons */
.stops-btn {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    color: white !important;
}

.stops-btn:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3) !important;
}

/* Add Button */
.add-btn {
    background: linear-gradient(135deg, #014b8f 0%, #1e40af 100%) !important;
    border: none !important;
    height: 45px !important;
    padding: 0 2rem !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 0.95rem !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 2px 4px rgba(1, 75, 143, 0.3) !important;
    color: white !important;
}

.add-btn:hover {
    background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(1, 75, 143, 0.4) !important;
}

.add-btn:active {
    transform: translateY(0) !important;
}

.add-btn:focus {
    box-shadow: 0 0 0 3px rgba(1, 75, 143, 0.1) !important;
}

/* ========================================
   STATUS BADGE STYLES - GLOBAL
   ======================================== */

.status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25em 0.8em;
    border-radius: 1em;
    font-weight: 600;
    font-size: 0.95em;
    letter-spacing: 0.5px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    gap: 0.4em;
}

.status-badge.cancelled {
    background: #ffeaea;
    color: #e53935;
    border: 1px solid #e53935;
}

.status-badge.hiddenStatus {
    background: #fff6e5;
    color: #f59e42;
    border: 1px solid #f59e42;
}

.status-badge.ended {
    background: #e3e3e3;
    color: #252d9c;
    border: 1px solid #252d9c;
}

.status-badge.started {
    background: #e3f2fd;
    color: #1976d2;
    border: 1px solid #1976d2;
}

.status-badge.active {
    background: #e8f5e9;
    color: #43a047;
    border: 1px solid #43a047;
}

/* Status Indicators */
.status-indicator {
    border-radius: 50%;
    height: 14px;
    width: 14px;
    margin-right: 0.5rem;
}

.status-indicator.active {
    background-color: #014b8f;
}

.status-indicator.inactive {
    background-color: #ff5e5e;
}

.status-text {
    font-weight: 600;
    margin: 0;
}

.status-text.active {
    color: #014b8f;
}

.status-text.inactive {
    color: #ff5e5e;
}

/* ========================================
   EMPTY STATE STYLES - GLOBAL
   ======================================== */

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    text-align: center;
}

/* ========================================
   PAGINATION STYLES - GLOBAL
   ======================================== */

.enhanced-table .p-paginator {
    background: #f8fafc !important;
    border: none !important;
    padding: 1rem !important;
    border-top: 1px solid #e5e7eb !important;
}

.enhanced-table .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: #014b8f !important;
    color: white !important;
    border-color: #014b8f !important;
}

.enhanced-table .p-paginator .p-paginator-pages .p-paginator-page:hover {
    background: #dbeafe !important;
    color: #014b8f !important;
}

/* ========================================
   FILTER MENU ENHANCEMENTS - GLOBAL
   ======================================== */

.p-column-filter-menu {
    border-radius: 8px !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
}

/* ========================================
   TABLE CELL TEXT DIRECTION - GLOBAL
   ======================================== */

.enhanced-table .p-datatable-tbody > tr > td {
    text-align: right;
}

.enhanced-table .p-datatable-tbody > tr > td[dir="ltr"] {
    text-align: left;
}

.enhanced-table .p-datatable-thead > tr > th {
    text-align: right;
}

.enhanced-table .p-datatable-thead > tr > th[dir="ltr"] {
    text-align: left;
}

/* ========================================
   FROZEN COLUMN STYLES - GLOBAL
   ======================================== */

/* 1. Ensure frozen columns inherit the correct background */
.p-datatable .p-datatable-tbody > tr > td.p-frozen-column {
    background: inherit;
}

/* 2. Add a precise, directional shadow */

/* LTR: Shadow on the left of the right-frozen column */
[dir="ltr"] .p-datatable-tbody > tr > td.p-frozen-column {
    box-shadow: -4px 0 4px -4px rgba(0, 0, 0, 0.15);
}

/* RTL: Shadow on the right of the left-frozen column */
[dir="rtl"] .p-datatable-tbody > tr > td.p-frozen-column {
    box-shadow: 4px 0 4px -4px rgba(0, 0, 0, 0.15);
}

/* ========================================
   RESPONSIVE DESIGN - GLOBAL
   ======================================== */

@media (max-width: 1400px) {
    .single-row-layout {
        grid-template-columns: 1fr 1fr;
        gap: 0.75rem;
    }
}

@media (max-width: 1200px) {
    .single-row-layout {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .filter-dropdown {
        min-width: 100%;
    }
}

@media (max-width: 768px) {
    .search-filters-section {
        padding: 1rem;
    }

    .filter-dropdown {
        min-width: 100%;
    }

    .search-btn {
        width: 100%;
        justify-content: center;
    }

    .column-header {
        font-size: 0.8rem;
    }

    .column-header i {
        display: none;
    }

    .cell-content {
        font-size: 0.8rem;
        padding: 0.25rem 0;
    }

    .action-btn {
        padding: 0.4rem 0.6rem !important;
        font-size: 0.8rem;
    }
    
    /* Ensure Actions column is always visible on mobile */
    .actions-cell {
        min-width: 150px;
        flex-direction: column;
        gap: 0.25rem;
    }
    
    .action-btn {
        padding: 0.3rem 0.5rem !important;
        font-size: 0.7rem;
    }
}

/* ========================================
   UTILITY CLASSES - GLOBAL
   ======================================== */

.iconClass {
    direction: rtl !important;
}

.acceptButtonClass {
    background: #014b8f !important;
    border: 1px solid #014b8f !important;
}

.acceptButtonClass:hover {
    background: #014b8f;
    color: #ffffff;
    border-color: #014b8f;
}

.status-icon.cancelled {
    color: #e53935;
    font-size: 1.3em;
}

.status-icon.hiddenStatus {
    color: #252d9c;
    font-size: 1.3em;
}

.status-icon.active {
    color: #43a047;
    font-size: 1.3em;
}

.status-text.cancelled {
    color: #e53935;
    font-weight: bold;
}

.status-text.hiddenStatus {
    color: #f59e42;
    font-weight: bold;
}

.status-text.active {
    color: #43a047;
    font-weight: bold;
}

.elapsed-badge {
    display: inline-flex;
    align-items: center;
    background: #f3f6fd;
    color: #1976d2;
    border: 1px solid #1976d2;
    border-radius: 1em;
    padding: 0.2em 0.9em;
    font-weight: 600;
    font-size: 0.95em;
    gap: 0.4em;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-filter{
    padding-right: 0;
    margin-right: 0;
}

/* Responsive adjustments for filter groups */
@media (min-width: 1400px) {
    .single-row-layout {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 1.5rem;
    }
    
    .filter-group {
        min-width: 250px;
        max-width: 350px;
    }
    
    .search-input,
    .filter-dropdown {
        min-width: 250px;
        max-width: 350px;
    }
}

@media (max-width: 1399px) and (min-width: 1200px) {
    .single-row-layout {
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
    }
    
    .filter-group {
        min-width: 220px;
        max-width: 300px;
    }
    
    .search-input,
    .filter-dropdown {
        min-width: 220px;
        max-width: 300px;
    }
}

@media (max-width: 1199px) and (min-width: 768px) {
    .single-row-layout {
        grid-template-columns: 1fr 1fr;
        gap: 0.75rem;
    }
    
    .filter-group {
        min-width: 200px;
        max-width: 280px;
    }
    
    .search-input,
    .filter-dropdown {
        min-width: 200px;
        max-width: 280px;
    }
}

@media (max-width: 767px) {
    .single-row-layout {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .filter-group {
        min-width: 100%;
        max-width: 100%;
    }
    
    .search-input,
    .filter-dropdown {
        min-width: 100%;
        max-width: 100%;
    }
}

/* Ensure proper alignment in RTL */
[dir="rtl"] .filter-group {
    text-align: right;
}

[dir="rtl"] .filter-label {
    text-align: right;
}

/* Ensure proper alignment in LTR */
[dir="ltr"] .filter-group {
    text-align: left;
}

[dir="ltr"] .filter-label {
    text-align: left;
}

/* Corporate dropdown specific styles */
.corporate-dropdown {
    width: 100%;
    min-width: 0;
    max-width: 100%;
}

.corporate-dropdown .p-dropdown {
    width: 100%;
    min-width: 0;
}

/* Mobile specific adjustments */
@media (max-width: 480px) {
    .search-filters-section {
        padding: 1rem;
    }
    
    .filter-group {
        margin-bottom: 0.5rem;
    }
    
    .search-input,
    .filter-dropdown {
        min-width: 100%;
        max-width: 100%;
    }
    
    .filter-label {
        font-size: 0.85rem;
        margin-bottom: 0.25rem;
    }
}

/* ========================================
   AGGRESSIVE FILTER SPACING - GLOBAL
   ======================================== */

/* Force spacing for all filter triggers in RTL */
[dir="rtl"] .p-column-filter-trigger {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}

/* Force spacing for all filter triggers in LTR */
[dir="ltr"] .p-column-filter-trigger {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}

/* Enhanced table specific aggressive spacing */
.enhanced-table[dir="rtl"] .p-column-filter-trigger {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}

.enhanced-table[dir="ltr"] .p-column-filter-trigger {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}

/* Column header padding adjustments */
.enhanced-table[dir="rtl"] .p-datatable-thead > tr > th {
    padding-right: 1.5rem !important;
    padding-left: 0.5rem !important;
}

.enhanced-table[dir="ltr"] .p-datatable-thead > tr > th {
    padding-left: 1.5rem !important;
    padding-right: 0.5rem !important;
}

/* PrimeVue specific targeting */
.p-datatable[dir="rtl"] .p-column-filter-trigger {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}

.p-datatable[dir="ltr"] .p-column-filter-trigger {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}

/* ========================================
   INTERNAL FILTER ELEMENT SPACING - GLOBAL
   ======================================== */







/* Force spacing for all filter-related elements in RTL */
[dir="rtl"] .p-column-filter-trigger * {
    margin-left: 0.5rem !important;
    margin-right: 0 !important;
}

/* Force spacing for all filter-related elements in LTR */
[dir="ltr"] .p-column-filter-trigger * {
    margin-right: 0.5rem !important;
    margin-left: 0 !important;
}


/* ========================================
   ULTIMATE FILTER SPACING - GLOBAL
   ======================================== */

/* Ultimate RTL filter spacing - target everything */
.enhanced-table[dir="rtl"] .p-datatable-thead > tr > th .p-column-filter-trigger,
.enhanced-table[dir="rtl"] .p-datatable-thead > tr > th .p-column-filter-trigger-icon,
.enhanced-table[dir="rtl"] .p-datatable-thead > tr > th .p-column-filter-trigger-button,
.enhanced-table[dir="rtl"] .p-datatable-thead > tr > th .p-column-filter-trigger * {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}
[dir="rtl"] .p-column-header-content span{
margin-inline-end: 9px;
}
[dir="ltr"] .p-column-header-content span{
margin-inline-start: 8px;
}
/* Ultimate LTR filter spacing - target everything */
.enhanced-table[dir="ltr"] .p-datatable-thead > tr > th .p-column-filter-trigger,
.enhanced-table[dir="ltr"] .p-datatable-thead > tr > th .p-column-filter-trigger-icon,
.enhanced-table[dir="ltr"] .p-datatable-thead > tr > th .p-column-filter-trigger-button,
.enhanced-table[dir="ltr"] .p-datatable-thead > tr > th .p-column-filter-trigger * {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}

/* Force spacing for all PrimeVue filter elements in RTL */
.p-datatable[dir="rtl"] .p-column-filter-trigger,
.p-datatable[dir="rtl"] .p-column-filter-trigger-icon,
.p-datatable[dir="rtl"] .p-column-filter-trigger-button,
.p-datatable[dir="rtl"] .p-column-filter-trigger * {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}

/* Force spacing for all PrimeVue filter elements in LTR */
.p-datatable[dir="ltr"] .p-column-filter-trigger,
.p-datatable[dir="ltr"] .p-column-filter-trigger-icon,
.p-datatable[dir="ltr"] .p-column-filter-trigger-button,
.p-datatable[dir="ltr"] .p-column-filter-trigger * {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}

/* Universal RTL filter spacing - most aggressive */
[dir="rtl"] .p-column-filter-trigger,
[dir="rtl"] .p-column-filter-trigger-icon,
[dir="rtl"] .p-column-filter-trigger-button,
[dir="rtl"] .p-column-filter-trigger * {
    margin-left: 1rem !important;
    margin-right: 0 !important;
}

/* Universal LTR filter spacing - most aggressive */
[dir="ltr"] .p-column-filter-trigger,
[dir="ltr"] .p-column-filter-trigger-icon,
[dir="ltr"] .p-column-filter-trigger-button,
[dir="ltr"] .p-column-filter-trigger * {
    margin-right: 1rem !important;
    margin-left: 0 !important;
}
.p-menu .p-menuitem > .p-menuitem-content .p-menuitem-link .p-menuitem-icon {
 margin-right: 0rem;

  margin-inline-end: 0.5rem !important;
}

.p-paginator .p-dropdown .p-dropdown-label {
     padding-right: 0;
     padding-inline-end: 0;
     padding-inline-start: 0.5rem;
}

 .p-inputtext,  .p-dropdown {
    padding: 5px !important;
}

.stopsContainer [dir="ltr"] .search-input,
[dir="ltr"] .search-input {
  padding-left: 2.5rem !important; /* leave space for the left icon */
  padding-right: 0.75rem !important;
}
.stopsContainer [dir="rtl"] .search-input,
[dir="rtl"] .search-input {
  padding-right: 2.5rem !important; /* leave space for the right icon in RTL */
  padding-left: 0.75rem !important;
}
</style>
